module.exports = "../images/pano-background-wall-4.jpg";